import { environment } from '@environment';

export type ApimService = keyof typeof environment.paths;

function normalizePath(path: string | undefined): string {
  const value = (path ?? '').trim();
  if (!value) return '';
  return value.startsWith('/') ? value : `/${value}`;
}

function stripTrailingSlash(value: string | undefined): string {
  return (value ?? '').replace(/\/+$/, '');
}

/**
 * Build the base HTTP URL for a service that lives behind APIM.
 * Composes `apim.baseUrl` (host, no trailing slash) with the per-service path
 * exposed in `environment.paths`. Both inputs are tolerant of empty strings so
 * the helper works in local development (where the backend serves at root) and
 * in deployed builds (where `loadRuntimeConfig` hydrates the values).
 */
export function httpUrl(service: ApimService): string {
  const base = stripTrailingSlash(environment.apim?.baseUrl);
  const suffix = normalizePath(environment.paths?.[service]);
  return `${base}${suffix}`;
}

/**
 * Build the base WebSocket URL for a service. Same composition as `httpUrl`
 * but with the protocol switched (`https` → `wss`, `http` → `ws`).
 */
export function wsUrl(service: ApimService): string {
  return httpUrl(service)
    .replace(/^https:/i, 'wss:')
    .replace(/^http:/i, 'ws:');
}
